export default __webpack_public_path__ + "static/media/close.3ba89ae4.svg";